var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AdminLayout } from 'src/Layouts';
import React, { useState, useMemo, useEffect } from 'react';
import ServerPaginatedTable from 'src/Components/Common/ServerPaginatedTable';
import Button from 'src/Components/Common/AdminButton/Button';
import { ticketsService } from 'src/Utils/ticketsService';
import { Container, TableContainer, Title, TopBar, TicketAlertMessage, BuildingFilterWrapper, } from './styles';
import dayjs from 'dayjs';
import FilterDropdown from 'src/Components/FilterDropdown';
import { useHistory } from 'react-router-dom';
import { useBuildingOptions } from 'src/Utils/hooks/useBuildingOptions';
import { ROUTES, TICKET_ALERTS_API } from '../../Utils/constants';
import Modal from 'src/Components/Common/DeleteModal';
import { useMutation, useQueryCache } from 'react-query';
import { useSearchParams } from 'src/Utils/hooks/useSearchParams';
import { getSearchParams } from 'src/Utils/getQueryParams';
import { SUCCESS_MESSAGES } from 'src/Utils/toastMessages';
import { showSuccessToast } from 'src/Utils/toastHelper';
var TicketAlerts = function () {
    var history = useHistory();
    var searchParams = useSearchParams();
    var _a = useState(searchParams.get('building_id')
        ? Number(searchParams.get('building_id'))
        : null), buildingId = _a[0], setBuildingId = _a[1];
    var _b = useState(false), isDeleteModalOpen = _b[0], setIsDeleteModalOpen = _b[1];
    var _c = useState(null), ticketAlertIdToDelete = _c[0], setTicketAlertIdToDelete = _c[1];
    var queryCache = useQueryCache();
    var deleteTicketAlert = useMutation(function () { return ticketsService.deleteTicketAlert(buildingId, ticketAlertIdToDelete); }, {
        onSuccess: function () {
            showSuccessToast(SUCCESS_MESSAGES.ticketAlerts.deleted);
            queryCache.invalidateQueries([TICKET_ALERTS_API, buildingId]);
        },
    })[0];
    var columns = useMemo(function () { return [
        {
            label: 'Mensaje',
            render: function (ticketAlertRow) { return (React.createElement(TicketAlertMessage, null, ticketAlertRow.message)); },
        },
        {
            label: 'Apartamento',
            render: function (ticketAlertRow) { var _a; return (_a = ticketAlertRow.apartmentNumber) !== null && _a !== void 0 ? _a : '-'; },
            sortingFieldName: 'apartment_number',
        },
        {
            label: 'Fecha de creación',
            render: function (ticketAlertRow) {
                return dayjs(ticketAlertRow.createdAt).format('DD/MM/YY hh:mm a');
            },
        },
        {
            label: 'Creado por',
            render: function (ticketAlertRow) { return ticketAlertRow.createdBy; },
        },
    ]; }, []);
    var rowActions = useMemo(function () { return [
        {
            label: 'Editar',
            value: 'edit',
            handler: function (ticketAlert) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    history.push("/alertas_tickets/" + buildingId + "/" + ticketAlert.id + "/editar");
                    return [2 /*return*/];
                });
            }); },
        },
        {
            label: 'Eliminar',
            value: 'delete',
            handler: function (ticketAlert) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    setTicketAlertIdToDelete(ticketAlert.id);
                    setIsDeleteModalOpen(true);
                    return [2 /*return*/];
                });
            }); },
        },
    ]; }, [buildingId]);
    var buildingOptions = useBuildingOptions().buildingOptions;
    useEffect(function () {
        if (!buildingOptions || buildingOptions.length < 1 || buildingId) {
            return;
        }
        setBuildingId(buildingOptions[0].value);
    }, [buildingOptions]);
    var fetchTicketAlerts = function (paginationParams) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ticketsService.getTicketAlerts(buildingId, paginationParams)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, {
                            totalPages: response.total_pages || 1,
                            data: response.ticket_alerts.map(function (ticketAlert) {
                                var _a, _b;
                                return ({
                                    id: ticketAlert.id,
                                    message: ticketAlert.message,
                                    createdBy: ticketAlert.created_by.first_name + " " + ticketAlert.created_by.last_name,
                                    createdById: ticketAlert.created_by.id,
                                    createdAt: ticketAlert.created_at,
                                    apartmentId: (_a = ticketAlert.apartment) === null || _a === void 0 ? void 0 : _a.id,
                                    apartmentNumber: (_b = ticketAlert.apartment) === null || _b === void 0 ? void 0 : _b.number,
                                });
                            }),
                        }];
            }
        });
    }); };
    var handleDelete = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (buildingId && ticketAlertIdToDelete) {
                deleteTicketAlert();
            }
            setIsDeleteModalOpen(false);
            return [2 /*return*/];
        });
    }); };
    var handleCreate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var searchParams;
        return __generator(this, function (_a) {
            searchParams = getSearchParams({ building_id: buildingId });
            history.push(ROUTES.crear_alerta_tickets + (searchParams ? "?" + searchParams : ''));
            return [2 /*return*/];
        });
    }); };
    return (React.createElement(AdminLayout, null,
        React.createElement(Container, null,
            React.createElement(Title, null, "Alertas para tickets"),
            React.createElement(TableContainer, null,
                React.createElement(TopBar, null,
                    React.createElement(BuildingFilterWrapper, null,
                        React.createElement(FilterDropdown, { label: "Edificio", placeholder: "Seleccione un edificio", value: buildingId, onChange: function (value) {
                                return setBuildingId(value ? Number(value) : null);
                            }, options: buildingOptions })),
                    React.createElement(Button, { onClick: handleCreate }, "Crear alerta")),
                React.createElement(ServerPaginatedTable, { key: buildingId !== null && buildingId !== void 0 ? buildingId : 'no-building', fetchData: fetchTicketAlerts, queryKey: [TICKET_ALERTS_API, buildingId], enabled: buildingId !== null, columns: columns, getRowKey: function (row) { return row.id; }, rowActions: rowActions }))),
        React.createElement(Modal, { isOpen: isDeleteModalOpen, setIsOpen: setIsDeleteModalOpen, itemLabel: "la alerta para tickets", onDelete: handleDelete })));
};
export default TicketAlerts;
